import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { CollapseInfo } from 'pages/SignupPage/Signup2/components/SelfLoanForTUErrors/components/CollapseInfo/CollapseInfo';
import { Link } from 'components/navigation/Link/Link';
import { Image } from 'components/Image/Image';

import LightBulb from 'style/_assets/notificationsAlerts/art-lightbulb.png';
import { ReactComponent as ChevronUp } from 'style/_assets/icons/chevron-up.svg';
import { ReactComponent as ChevronDown } from 'style/_assets/icons/chevron-down.svg';
import { ConditionalRendering } from 'helpers/conditionalRedering.helper';
import { Button } from 'components/form/Button';
import OText from 'components/CText/OText';

const TakeTip = ({ tipText }) => {
  return (
    <FlexContainer column>
      <FlexContainer className="margb6">
        <img src={LightBulb} alt="lightbulb" />
        <Label className="margl4 bold" type="Body2">
          TIP
        </Label>
      </FlexContainer>
      <FlexContainer className="padb10">
        <div className="borderLeft1 borderNeutral050 marglr8 "></div>
        <Label type="Body2">{tipText}</Label>
      </FlexContainer>
    </FlexContainer>
  );
};

const ActionsYouCanTake = props => {
  const showTip =
    props?.config?.notificationAlerts?.accountImproved?.ActionsYouCanTakeTip;
  return (
    <FlexContainer column>
      <Label className={'H4 margT40 m-margT20'}>{props?.title}</Label>
      <Label className={'Body-2  margT16'}>{props?.subTitle}</Label>
      {props?.actionsYouCanTake?.map(action => (
        <div key={action?.title?.split(' ').join()}>
          <CollapseInfo
            title={
              <Label className={'Subtitle-1 mSubtitle-1'}>
                {action?.title}
              </Label>
            }
            context={
              <>
                <ConditionalRendering isTrue={action?.takeTip}>
                  <Label className={'Body-2 mBody-2 margB16'}>
                    {action?.subtitle}
                  </Label>
                  {showTip && <TakeTip tipText={action?.takeTip?.tipContent} />}
                </ConditionalRendering>
                <ConditionalRendering isTrue={action?.takeAction}>
                  <TakeActionBox
                    subtitle={action?.subtitle}
                    takeAction={action?.takeAction}
                    listLinkCallback={props?.listLinkCallback}
                    creditInfo={props?.creditInfo}
                  />
                </ConditionalRendering>
                <ConditionalRendering isTrue={action?.takeLink}>
                  <Label className={'Body-1 mBody-2 margB16'}>
                    {action?.subtitle}
                  </Label>
                  <Link
                    to={action?.takeLink?.link}
                    onClickCallback={props?.listLinkCallback}
                    link={action?.takeLink?.description}
                    Vertical={action?.takeLink?.vertical}
                    clickTile={action?.takeLink?.clickTile}
                  >
                    <Button mrphType="standard">
                      {action?.takeLink?.clickTile}
                    </Button>
                  </Link>
                </ConditionalRendering>
                <ConditionalRendering isTrue={action?.isSimpleAction}>
                  <Label className={'Body-2 mBody-2   margB16'}>
                    <OText text={action?.subtitle} />
                  </Label>
                </ConditionalRendering>
              </>
            }
            iconUp={<ChevronUp />}
            iconDown={<ChevronDown />}
            removePadding
          />
          <div className="margt20 bgGray050" style={{ height: '1px' }}></div>
        </div>
      ))}
    </FlexContainer>
  );
};

const TakeActionBox = props => {
  const { subtitle, takeAction, listLinkCallback } = props;

  return (
    <>
      <Label className={'Body-1 mBody-2   margB16'}>{subtitle}</Label>
      <Link
        to={takeAction.link}
        onClickCallback={listLinkCallback}
        link={takeAction?.description}
        Vertical={takeAction?.vertical}
        clickTile={takeAction.clickTile}
      >
        <FlexContainer
          className={
            'bgGray0 format100 margB16 border-rad10px  padTB8 padLR16 align-items-center justify-between'
          }
          style={{ height: '72px' }}
        >
          <Image className={takeAction?.icon} />

          <div className="margL14" style={{ width: '330px' }}>
            <Label className={'subTitle1 mSubtitle-1 secondary_text_light'}>
              {takeAction?.title}
            </Label>
          </div>

          <Image className={'rightArrowIcon'} />
        </FlexContainer>
      </Link>
    </>
  );
};
export default ActionsYouCanTake;
